import { render, staticRenderFns } from "./Advertiser.vue?vue&type=template&id=509c2d84"
import script from "./Advertiser.vue?vue&type=script&lang=js"
export * from "./Advertiser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports